import React, { createContext, useState, useEffect } from "react";
import { api } from "../../../utils/api";
import { toast } from "react-toastify";

export const ObservationContext = createContext();

export const ObservationContextProvider = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadObservations = async (filters = {}) => {
    try {
      setLoading(true);
      const response = await api.getObservations(filters);
      
      // Laravel pagination retourne { data: [...], current_page: 1, ... }
      // ou directement un tableau si pas de pagination
      let observations = [];
      if (response) {
        if (response.data !== undefined && Array.isArray(response.data)) {
          // Structure de pagination Laravel
          observations = response.data;
        } else if (Array.isArray(response)) {
          // Réponse directe en tableau
          observations = response;
        } else if (typeof response === 'object') {
          // Chercher un tableau dans les valeurs de l'objet
          const arrayValue = Object.values(response).find(val => Array.isArray(val));
          if (arrayValue) {
            observations = arrayValue;
          }
        }
      }
      
      // S'assurer que toutes les observations ont les champs nécessaires
      const observationsArray = Array.isArray(observations) ? observations.map(obs => {
        // S'assurer que les champs sont bien présents
        return {
          ...obs,
          type: obs.type || null,
          severity: obs.severity || null,
          status: obs.status || 'submitted',
        };
      }) : [];
      
      setData(observationsArray);
    } catch (error) {
      toast.error("Erreur lors du chargement des observations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadObservations();
  }, []);

  return (
    <ObservationContext.Provider
      value={{
        contextData: [data, setData],
        loading,
        loadObservations,
      }}
    >
      {props.children}
    </ObservationContext.Provider>
  );
};

